  <template lang="pug">
v-stepper(v-model="e1")
  v-stepper-header
    v-stepper-step(:complete="e1 > 1", step="1") Detail Izin
    v-divider
    v-stepper-step(:complete="e1 > 2", step="2") Detail Tamu

  v-stepper-items
    v-stepper-content(step="1")
      v-card.mb-12.mt-6(height="auto")
        v-layout(row, wrap)
          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Judul Izin
          v-flex(xs7, sm5)
            v-text-field.inputDefault(
              v-model="judulPekerjaan",
              label="Judul Izin"
              id="fit-judul-izin" 
            )
          v-flex(xs1, sm4)

          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Penanggung Jawab
          v-flex(xs7, sm5)
            v-menu(
              v-model="searchpenanggungJawab",
              :close-on-content-click="false",
              :nudge-right="40",
              transition="scale-transition",
              offset-y,
              min-width="290px"
            )
              template(v-slot:activator="{ on }")
                v-text-field(
                  v-model="penanggungJawab.name",
                  label="Penanggung Jawab",
                  id="fit-penanggung-jwb"
                  readonly,
                  v-on="on"
                )
              PemegangModal(
                :searchPemegang="searchpenanggungJawab",
                @interface="searchpenanggungJawab = false",
                @selectedUser="updatePenanggungJawab"
              )
          v-flex(xs1, sm4)

          v-flex(xs4, sm3) 
            p.headerSection 
              span.mustFill *
              span Department
          v-flex(xs7, sm5)
            v-autocomplete.inputDefault(
              v-model="deptDivisi",
              id="fit-dept-divisi"
              :items="dataUsers.department",
              label="Department"
            )
          v-flex(xs1, sm4)

          v-flex(xs4, sm3) 
            p.headerSection 
              span.mustFill *
              span Perusahaan
          v-flex(xs7, sm5)
            v-autocomplete.inputDefault(
              v-model="perusahaan",
              id="fit-perusahaan"
              :items="dataUsers.companies",
              label="Perusahaan"
            )
          v-flex(xs1, sm4)

          v-flex(xs3, sm3) 
            p.headerSection 
              span.mustFill *
              span Tanggal Kunjungan
          v-flex(xs4, sm2)
            v-menu(
              v-model="startMenu",
              :close-on-content-click="false",
              :nudge-right="40",
              transition="scale-transition",
              offset-y,
              min-width="290px"
            )
              template(v-slot:activator="{ on }")
                v-text-field(
                  v-model="startDate",
                  label="mulai dari",
                  prepend-icon="event",
                  id="fit-tgl-kunjungan-start"
                  readonly,
                  v-on="on"
                )
              v-date-picker(
                v-model="startDate",
                @input="clearDate",
                id="fit-tgl-picker-start"
                :min="todayDate"
              )
          v-flex(xs4, sm2)
            v-menu(
              v-model="endMenu",
              :close-on-content-click="false",
              :nudge-right="40",
              transition="scale-transition",
              offset-y,
              min-width="290px"
            )
              template(v-slot:activator="{ on }")
                v-text-field(
                  v-model="endDate",
                  label="sampai dengan",
                  id="fit-tgl-kunjungan-end"
                  prepend-icon="event",
                  readonly,
                  v-on="on"
                )
              v-date-picker(
                v-model="endDate",
                @input="endMenu = false",
                id="fit-tgl-picker-end"
                :min="startDate ? startDate :todayDate"
              )
          v-flex(xs1, sm4)

          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Tujuan Kunjungan
          v-flex(xs7, sm5)
            v-text-field.inputDefault(
              v-model="tujuanKunjungan",
              label="Tujuan Kunjungan"
              id="fit-tujuan-kunjungan"
            )
          v-flex(xs1, sm4)

          v-flex(xs4, sm3) 
            p.headerSection 
              span.mustFill *
              span Lokasi Kunjungan
          v-flex(xs7, sm5)
            v-autocomplete.inputDefault(
              label="Lokasi Kunjungan",
              v-model="lokasi",
              id="fit-lokasi-kunjungan"
              :items="locations.data",
              no-data-text="No Data",
              color="blue-grey lighten-2",
              item-text="location_name",
              item-value="data",
              clearable,
              chips,
              multiple
            ) 
          v-flex(xs1, sm4)

          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Detail Lokasi
          v-flex(xs7, sm5)
            v-text-field.inputDefault(
              v-model="subLokasi",
              label="Detail Lokasi",
              id="fit-detail-lokasi"
              counter="100",
              maxlength="100",
              height="42"
            )
          v-flex(xs1, sm4)
          v-flex(xs4, sm3)
            p.headerSection 
              span.mustFill *
              span Klasifikasi
          v-flex(xs7, sm5)
            v-autocomplete.inputDefault(
              label="Klasifikasi",
              id="fit-klasifikasi",
              v-model="klasifikasi",
              :items="dataKlasifikasi",
              no-data-text="No Data",
              color="blue-grey lighten-2",
              item-text="ipTitle",
              return-object,
              clearable,
              chips
            )
          v-flex(xs1, sm4)

          v-flex(xs4, sm3 style="padding-top:-10px")
            p.headerSection 
              span.mustFill *
              span Akomodasi
          v-flex(xs7, sm5)
            v-radio-group(id="fit-akomodasi" v-model="akomodasi",  row style="margin-top:-5px")
              v-radio(label="Ya", value="Ya")
              v-radio(label="Tidak", value="Tidak")
          v-flex(xs1, sm4)

          v-flex(xs4, sm3 style="padding-top:-5px")
            p.headerSection 
              span.mustFill *
              span APD
          v-flex(xs7, sm5 style="padding-top:-5px")
            v-radio-group(id="fit-apd" v-model="apd", row style="margin-top:-5px")
              v-radio(label="Ya", value="Ya")
              v-radio(label="Tidak", value="Tidak")
          v-flex(xs1, sm4)

          v-flex(xs4, sm3 style="padding-top:2px") 
            p.headerSection 
              span.mustFill *
              span Transportasi
          v-flex(xs7, sm5)
            v-radio-group(id="fit-transportasi" v-model="transportasi", row style="margin-top:-5px")
              v-radio(label="Ya", value="Ya")
              v-radio(label="Tidak", value="Tidak")
          v-flex(xs1, sm4)

          v-flex(xs4, sm3 style="padding-top:15px") 
            p.headerSection 
              span.mustFill *
              span Dokument ltinerary
          v-flex.attachment(
            xs7,
            sm5,
            v-if="!docPendukung || docPendukung.size > 10000000"
          )
            v-row
              v-col
                v-file-input(
                  :rules="rules",
                  label="Hanya 1 file, max 10MB",
                  id="fit-document"
                  v-model="docPendukung"
                  accept=".pdf,.png,.jpg,.jpeg"
                )
                  template(v-slot:selection="{ text }")
                    v-chip(small, label, color="primary") {{ text }}
              v-col
          v-flex.attachmentName(
            xs7,
            sm5,
            v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)"
          )
            v-row
              v-col
                span(id="fit-document") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                v-btn(
                  icon,
                  color="red",
                  @click="deleteDocPendukung('docPendukung')"
                )
                  v-icon mdi-close
                p(v-if="docPendukung && docPendukung != emptyUpload") <br/><br/>
              v-col
          v-flex(xs1, sm4)

      v-btn(text, style="margin-right: 20px", @click="backHome()") Cancel
      v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
      //- v-btn(color="primary", @click="e1 = 2; scrollTop()") Continue

    v-stepper-content(step="2")
      v-card.mb-12(height="auto")
        v-card(outlined class="mx-auto" style="padding:10px")
          v-layout(row, wrap)
            v-flex(xs12, sm12) 
              h3.headerSection Daftar Tamu
              br
          v-layout(row, wrap, v-for="(item, index) in visitor", :key="index" style="margin-top:-10px")
            v-flex(xs3, sm3)
              span.mustFill(style="padding-left: 30px") *
                v-text-field.inputDefault(
                  style="padding-left: 30px; margin-right: 20px",
                  v-model="item.name",
                  id="fit-nama-tamu"
                  placeholder="Nama Tamu",
                  :rules='[visitorRules.required]'
                )
            v-flex(xs2, sm2)
              span.mustFill *
                v-text-field.inputDefault(
                  style="margin-right: 20px",
                  v-model="item.company",
                  id="fit-perusahaan-tamu"
                  placeholder='Perusahaan',
                  :rules='[visitorRules.required]'
                )
            v-flex(xs2, sm2)
              span.mustFill *
                v-text-field.inputDefault(
                  style="margin-right: 20px",
                  v-model="item.position",
                  id="fit-jabatan-tamu"
                  placeholder='Jabatan',
                  :rules='[visitorRules.required]'
                )
            v-flex(xs2, sm2)
              span.mustFill *
                v-text-field.inputDefault(
                  style="margin-right: 20px",
                  v-model="item.email",
                  id="fit-email-tamu"
                  placeholder='Email',
                  :rules='[visitorRules.required, visitorRules.email]'
                )
            v-flex(xs2, sm2)
              span.mustFill *
                v-text-field.inputDefault(
                  style="margin-right: 20px",
                  v-model="item.phone",
                  placeholder='No Handphone',
                  id="fit-nohp-tamu"
                  maxlength='15'
                  counter
                  :rules='[visitorRules.required, visitorRules.phone]'
                )
            v-flex(xs1, sm1)
              v-btn.mt-5(icon, color="red", small @click='handleDeleteVisitor(index)') 
                v-icon(title="Edit") mdi-close-box
          v-layout(row, wrap)
        v-form(ref="form" v-model="valid" lazy-validation)
          v-card(outlined class="mx-auto" style="padding:10px;margin-top:50px")
            v-layout(row, wrap)
              v-flex(xs12, sm12) 
                h3.headerSection Input Tamu
                br
            v-layout(row, wrap)
              v-flex(xs3, sm3)
                span.mustFill(style="padding-left: 20px") *
                  v-text-field.inputDefault(
                    style="padding-left: 30px; margin-right: 20px",
                    v-model="visitorName",
                    placeholder="Nama Tamu",
                    id="fit-nama-tamu"
                    :disabled="isTamuMaxed"
                    :rules='[visitorRules.required]'
                  )
              v-flex(xs2, sm2)
                span.mustFill *
                  v-text-field.inputDefault(
                    style="margin-right: 20px",
                    v-model="visitorCompany",
                    placeholder="Perusahaan"
                    id="fit-perusahaan-tamu"
                    :disabled="isTamuMaxed"
                    :rules='[visitorRules.required]'
                  )
              v-flex(xs2, sm2)
                span.mustFill *
                  v-text-field.inputDefault(
                    style="margin-right: 20px",
                    v-model="visitorPosition",
                    placeholder="Jabatan",
                    id="fit-jabatan-tamu"
                    :disabled="isTamuMaxed"
                    :rules='[visitorRules.required]'
                  )
              v-flex(xs2, sm2)
                span.mustFill *
                  v-text-field.inputDefault(
                    style="margin-right: 20px",
                    v-model="visitorEmail",
                    placeholder="Email",
                    id="fit-email-tamu"
                    :disabled="isTamuMaxed"
                    :rules='[visitorRules.required, visitorRules.email]'
                  )
              v-flex(xs3, sm3)
                span.mustFill *
                  v-text-field.inputDefault(
                    style="margin-right: 20px",
                    v-model="visitorNoPhone",
                    id="fit-nohp-tamu"
                    placeholder="No Handphone"
                    maxlength='15'
                    counter
                    :disabled="isTamuMaxed"
                    :rules='[visitorRules.required, visitorRules.phone]'
                  )

            v-layout(row, wrap style="margin-top: 10px")
              v-flex(xs12, sm12)
                span.mustFill 
                  v-btn(
                    color="#4CAF50",
                    style="color: white; float: right; margin-right: 20px",
                    @click="handleListTamu"
                    :disabled="isTamuMaxed"
                  ) Tambah Tamu
                  br
                  br
                  br
      //- v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
      v-btn(text, style="margin-right: 20px", @click="backHome()") Cancel
      v-btn(
        color="#4CAF50",
        style="color: white;margin-right: 20px",
        @click="submit(1)",
      ) Save As Draft
      v-btn(color="primary", style="margin-right: 20px", @click="submit(2)" :disabled='!isPage2Complete') Submit
</template>

  <script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import PemegangModal from "./PemegangModal.vue";
import PermitUserModal from "./PermitUserModal.vue";
export default {
  name: "AddIzinTamu",
  components: {
    PemegangModal,
    PermitUserModal,
  },
  props: {
    edit: { type: Boolean, default: false },
    users: Array,
  },
  data() {
    return {
      visitor: [],
      valid: true,
      visitorName: "",
      visitorCompany: "",
      visitorPosition: "",
      visitorEmail: "",
      visitorNoPhone: "",
      dataKlasifikasi: [
        "Pekerja",
        "Studi",
        "Supplier",
        "Government",
        "Lain – lain",
      ],
      dataAkomodasi: ["Ya", "Tidak"],
      dataTransportasi: ["Ya", "Tidak"],
      e1: 1,
      formCode: "BIB-HSE-PPO-IZIN-TAMU",
      selectedLampiran: [],
      startMenu: false,
      startDate: "",
      endMenu: false,
      endDate: "",
      todayDate: new Date().toISOString().slice(0, 10),
      clockMenu: false,
      waktuPengawalan: "",
      jenisPengawalan: "",
      akomodasi: "",
      apd: "",
      transportasi: "",
      jobCategory: [
        { text: "Kategori 1", value: 1 },
        { text: "Kategori 2", value: 2 },
        { text: "Kategori 3", value: 3 },
        { text: "Kategori 4", value: 4 },
      ],
      selectedCategory: "",
      searchpenanggungJawab: false,
      judulPekerjaan: "",
      tujuanKunjungan: "",
      penanggungJawab: "",
      klasifikasi: "",
      perusahaan: "",
      deptDivisi: "",
      detailPengawalan: "",
      jumlahUnit: "",
      lokasi: "",
      subLokasi: "",
      pengawalanStartDuration: "",
      pengawalanEndDuration: "",
      lebarUnit: "",
      panjangUnit: "",
      tinggiUnit: "",
      beratUnit: "",
      temporaryAttachment: null,
      uploadId: null,
      docPendukung: null,
      submitClick: false,
      status: 0,
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },

  mounted: async function () {
    this.$store.dispatch("fetchLocations");
    this.$store.dispatch("fetchMyAttachmentToAttach");
    const isFromList = this.$route.query.list === "1";
    if (isFromList && this.selectedAttachment.length > 0) {
      this.selectedLampiran = this.selectedAttachment;
    }
    this.$store.commit("setSelectedAttachment", []);
    this.uploadId = Date.now();
  },
  computed: {
    ...mapState([
      "API_URL",
      "locations",
      "dataUsers",
      "dataEditRequest",
      "myFilteredAttachment",
      "selectedAttachment",
      "visitorRules"
    ]),
    selectedLoc() {
      let tempLoc = [];
      let locationCode;

      if (this.dataUsers.location instanceof Array) {
        locationCode = this.dataUsers.location[0];
      } else {
        locationCode = this.dataUsers.location;
      }

      for (let i = 0; i < this.lokasi.length; i++) {
        tempLoc.push({ code: locationCode, name: this.lokasi[i] });
      }
      return tempLoc;
    },
    isPage1Complete: function () {
      return (
        !!this.judulPekerjaan &&
        !!this.klasifikasi &&
        !!this.tujuanKunjungan &&
        !!this.subLokasi &&
        !!this.lokasi &&
        !!this.penanggungJawab &&
        !!this.startDate &&
        !!this.endDate &&
        (this.selectedLoc.length != 0) &&
        !(this.selectedLoc.length < 1) &&
        !!this.akomodasi &&
        !!this.apd &&
        !!this.transportasi &&
        !!this.deptDivisi &&
        !!this.perusahaan &&
        !!this.docPendukung
      );
    },
    isPage2Complete() {
      if (!this.visitor.length) return false;
      return this.visitor.every(visitee => visitee.name && visitee.company && 
          (visitee.email && (this.visitorRules.email(visitee.email) != 'Invalid e-mail.')) && 
          (visitee.phone && (this.visitorRules.phone(visitee.phone) != 'Invalid Phone Number Format')) && visitee.position);
    },
    isTamuMaxed() {
      return this.visitor.length >= 10;
    },
    userRole() {
      const roleObject = {
        "Unit Baru Masuk": {
          1: {
            HO: ["SECHEAD"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
          2: {
            HO: ["DIC"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
          3: {
            HO: ["DIVHEAD"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
          4: {
            HO: ["DIVHEAD"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
        },
        "Pindah Lokasi Kerja": {
          1: {
            HO: ["SECHEAD"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
          2: {
            HO: ["SECHEAD"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
          3: {
            HO: ["SECHEAD"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
          4: {
            HO: ["DIC"],
            MITRA: ["PJO"],
            PH3: ["PJO"],
          },
        },
      };
      return roleObject[this.jenisPengawalan][this.selectedCategory.toString()][
        this.dataUsers.location[0]
      ];
    },
  },
  methods: {
    handleListTamu() {
    this.$refs.form.validate();
      if(this.$refs.form.validate() === true) {
         this.visitor.push({
        name: this.visitorName,
        company: this.visitorCompany,
        position: this.visitorPosition,
        email: this.visitorEmail,
        phone: this.visitorNoPhone,
      });
        this.visitorName = "",
        this.visitorCompany = "",
        this.visitorNoPhone = "",
        this.visitorEmail = "",
        this.visitorPosition = ""
      }
    },
    handleDeleteVisitor(value){
       this.visitor.splice(value, 1);
    },
    updatePenanggungJawab(user) {
      this.penanggungJawab = user;
    },
    clearDate() {
      this.endDate = null;
      this.startMenu = false;
    },
    formatDate: helper.formatDate,
    scrollTop() {
      window.scrollTo(0, 0);
    },
    submit(status) {
      this.submitClick = true;
      this.status = status;
      let formData = {
        ipStatus : this.status ,
        ipJudulPekerjaan : this.judulPekerjaan ,
        ipTujuanKunjungan : this.tujuanKunjungan ,
        ipKlasifikasi : this.klasifikasi ,
        ipPemegangIzin : this.penanggungJawab ,
        ipTanggalKunjungan : this.startDate ,
        ipSelesaiKunjungan : this.endDate ,
        ipPerusahaan : this.perusahaan ,
        ipDeptDivisi : this.deptDivisi ,
        ipLocation : this.selectedLoc ,
        ipDetailLocation : this.subLokasi ,
        ipAkomodasi : this.akomodasi ,
        ipApd : this.apd ,
        ipTransportasi : this.transportasi ,
        ipItineraryUploadId :this.edit? this.uploadId : JSON.stringify(this.uploadId) ,
        ipUser : this.dataUsers ,
        ipForm : this.formCode ,
        ipVisitors : this.visitor 
      }
      if(this.edit){
        formData.ipNo = this.dataEditRequest.ipNo
      }
      const config = {
        method: this.edit ? "put" : "post",
        url: `${this.API_URL}/v1/requests/submitTamu`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: formData,
      };
      axios(config).then((res) => {
        this.$store.commit("temporaryData", res);
        // console.log(res);
        this.$router.push("/my-permit");
      });
    },
    deleteDocPendukung(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome() {
      this.$router.push("/my-permit");
    },
    backStep() {
      this.e1--;
    },
    docName(name) {
      return this.$setFilename(name);
    },
  },
  watch: {
    docPendukung(params) {
      if (params && params.size < 10000000) {
        // console.log(params)
        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append("docPendukung", params);
        axios.post(
          `${this.API_URL}/v1/requests/attachment/docPendukung`,
          formData,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        );
      }
    },
    dataEditRequest: async function () {
      await this.$store.dispatch(
        "fetchMyAttachmentToAttach",
        this.dataEditRequest.ipNo
      );
      this.lokasi = [];
      for (const loc of this.dataEditRequest.ipLocation) {
        this.lokasi.push(loc.name);
      }

      this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan
      this.tujuanKunjungan = this.dataEditRequest.ipTujuanKunjungan
      this.penanggungJawab = this.dataEditRequest.ipPemegangIzin
      this.startDate = this.formatDate(this.dataEditRequest.ipTanggalKunjungan).slice(0,10);
      this.endDate = this.formatDate(this.dataEditRequest.ipSelesaiKunjungan).slice(0,10);
      this.perusahaan = this.dataEditRequest.ipPerusahaan
      this.deptDivisi = this.dataEditRequest.ipDeptDivisi
      this.subLokasi = this.dataEditRequest.ipDetailLocation
      this.klasifikasi = this.dataEditRequest.ipKlasifikasi
      this.akomodasi = this.dataEditRequest.ipAkomodasi
      this.apd = this.dataEditRequest.ipApd
      this.transportasi = this.dataEditRequest.ipTransportasi
      this.uploadId = this.dataEditRequest.ipItineraryUploadId;
      this.docPendukung = this.dataEditRequest.ipItinerary?.docPendukung;
      this.visitor = this.dataEditRequest.ipVisitors
    },
  },
};
</script>

  <style>
.ck-editor__editable {
  min-height: 300px;
  max-height: 300px;
  resize: none;
}
.mustFill {
  color: #ea5164;
}
</style>
